import type { FC } from 'react';
import type { GridColDef } from '@mui/x-data-grid';
import type {
  HypothesisCreativeEntry,
  HypothesisGroup,
  HypothesisSection,
} from '../../types/hypothesis';
import CreativesGridSkeleton from './CreativesGridSkeleton';
import CreativesEmptyState from './CreativesEmptyState';
import CreativesGroupedView from './CreativesGroupedView';
import CreativesFlatGrid from './CreativesFlatGrid';

interface TestCreativesContentProps {
  isInitialLoading: boolean;
  hasResults: boolean;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
  groupByHypothesis: boolean;
  thisWeek: HypothesisGroup[];
  upcoming: HypothesisGroup[];
  noHypothesis: HypothesisCreativeEntry[];
  sortedFlatCreatives: HypothesisCreativeEntry[];
  selectedCreatives: string[];
  columns: GridColDef[];
  onGroupSelectionChange: (hypothesis: string, ids: string[]) => void;
  onFlatSelectionChange: (ids: string[]) => void;
  onSectionChange: (hypothesis: string, section: HypothesisSection) => void;
}

const TestCreativesContent: FC<TestCreativesContentProps> = ({
  isInitialLoading,
  hasResults,
  hasActiveFilters,
  onClearFilters,
  groupByHypothesis,
  thisWeek,
  upcoming,
  noHypothesis,
  sortedFlatCreatives,
  selectedCreatives,
  columns,
  onGroupSelectionChange,
  onFlatSelectionChange,
  onSectionChange,
}) => {
  if (isInitialLoading) {
    return <CreativesGridSkeleton />;
  }

  if (!hasResults) {
    return (
      <CreativesEmptyState
        hasActiveFilters={hasActiveFilters}
        onClearFilters={hasActiveFilters ? onClearFilters : undefined}
      />
    );
  }

  if (groupByHypothesis) {
    return (
      <CreativesGroupedView
        thisWeek={thisWeek}
        upcoming={upcoming}
        noHypothesis={noHypothesis}
        selectedCreatives={selectedCreatives}
        columns={columns}
        onSelectionChange={onGroupSelectionChange}
        onSectionChange={onSectionChange}
      />
    );
  }

  return (
    <CreativesFlatGrid
      rows={sortedFlatCreatives}
      columns={columns}
      selectedCreatives={selectedCreatives}
      onSelectionChange={onFlatSelectionChange}
    />
  );
};

export default TestCreativesContent;
